// extracted by mini-css-extract-plugin
module.exports = {"iconLogo":"_3Z7oDSmQ3-NY6TfkNM7ox7","iconLogo__background":"_2X2YbzeZyZly056ysPygO"};